import React from "react";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

const windowedPages = (current, totalPages, span = 2) => {
    const start = Math.max(1, Math.min(current - span, totalPages - span * 2));
    const end = Math.min(totalPages, Math.max(current + span, span * 2 + 1));
    const pages = [];
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
};

const Pagination = ({ current = 1, total = 0, pageSize = 10, onPageChange, onPageSizeChange, disabled = false }) => {
    const currentPage = Number(current) || 1;
    const totalPages = Math.max(1, Math.ceil((Number(total) || 0) / (Number(pageSize) || 10)));

    const goTo = (page) => {
        if (disabled || page < 1 || page > totalPages || page === currentPage) return;
        onPageChange?.(page);
    };

    const rangeLabel = total
        ? `Showing ${(currentPage - 1) * pageSize + 1}–${Math.min(currentPage * pageSize, total)} of ${total}`
        : `Page ${currentPage}`;

    return (
        <div className="list-pagination">
            <span className="list-pagination-range text-muted small">{rangeLabel}</span>

            <div className="list-pagination-controls">
                <button
                    type="button"
                    className="btn btn-sm list-page-btn"
                    onClick={() => goTo(currentPage - 1)}
                    disabled={disabled || currentPage <= 1}
                    aria-label="Previous page"
                >
                    <IoChevronBack /> <span className="d-none d-sm-inline">Previous</span>
                </button>

                {windowedPages(currentPage, totalPages).map((page) => (
                    <button
                        key={page}
                        type="button"
                        className={`btn btn-sm ${page === currentPage ? "list-page-current" : "list-page-btn"}`}
                        onClick={() => goTo(page)}
                        disabled={disabled}
                        aria-current={page === currentPage ? "page" : undefined}
                    >
                        {page}
                    </button>
                ))}

                <button
                    type="button"
                    className="btn btn-sm list-page-btn"
                    onClick={() => goTo(currentPage + 1)}
                    disabled={disabled || currentPage >= totalPages}
                    aria-label="Next page"
                >
                    <span className="d-none d-sm-inline">Next</span> <IoChevronForward />
                </button>
            </div>

            {onPageSizeChange ? (
                <div className="list-page-size">
                    <label htmlFor="list-page-size-select" className="text-muted small me-2">Rows per page</label>
                    <select
                        id="list-page-size-select"
                        className="form-select form-select-sm"
                        value={pageSize}
                        onChange={(e) => onPageSizeChange(Number(e.target.value))}
                        disabled={disabled}
                    >
                        {[10, 20, 50, 100].map((size) => (
                            <option key={size} value={size}>{size}</option>
                        ))}
                    </select>
                </div>
            ) : ""}
        </div>
    );
};

export default Pagination;
